import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { FileGroup } from '../../../beneficiari.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { BeneficiariService } from '../../../beneficiari.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-view-document',
    templateUrl: './view-document.component.html',
    styleUrls: ['./view-document.component.scss']
})
export class ViewDocumentComponent {
    helper = helper;
    isLoading = false;
    group!: FileGroup;

    eduStatus = [
        { name: 'În curs', value: 1 },
        { name: 'Finalizat', value: 2 },
        { name: 'Abandonat', value: 3 },
    ]

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            group: FileGroup;
            documentSections: Generic[];
            conditieMedicala: Generic[];
            evenimentGenealogic: Generic[];
            relatieType: Generic[];
            relatieSpecifica: Generic[];
        },
        private dialogRef: MatDialogRef<ViewDocumentComponent>,
        private beneficiariService: BeneficiariService,
        private appFilesService: AppFilesService,
    ) {
        this.group = this.data.group;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    getDocumentSectionsName(id: number) {
        return this.data.documentSections.find(item => item.id === id)?.name || '';
    }
    getConditieMedicalaName(id: number) {
        return this.data.conditieMedicala.find(item => item.id === id)?.name || '';
    }
    getEvenimentGenealogic(id: number) {
        return this.data.evenimentGenealogic.find(item => item.id === id)?.name || '';
    }
    getRelatieType(id: number) {
        return this.data.relatieType.find(item => item.id === id)?.name || '';
    }
    getRelatieSpecificaName(id: number) {
        return this.data.relatieSpecifica.find(item => item.id === id)?.name || '';
    }

    getEduStatusName(value: number) {
        return this.eduStatus.find(item => item.value === value)?.name || '';
    }

    downloadFile(id: number) {
        this.isLoading = true;
        const fullPath = this.beneficiariService.downloadFileUrl + id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }
}
